import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  refundStatus: {
    description: 'Label for refund status field',
    defaultMessage: 'Refund Status',
    id: 'xLO0Rh',
  },
  requestDate: {
    description: 'Label for refund request date field',
    defaultMessage: 'Request Date',
    id: 'l1hney',
  },
  amountPaid: {
    description: 'Label for amount paid field',
    defaultMessage: 'Amount Paid',
    id: 'H2lSi7',
  },
  requested: {
    description: 'Label for requested amount field',
    defaultMessage: 'Requested',
    id: 'pE29DV',
  },
  approved: {
    description: 'Label for approved amount field',
    defaultMessage: 'Approved',
    id: 'WbHsqC',
  },
  creditedAmount: {
    description: 'Label for credited amount field',
    defaultMessage: 'Credited Amount',
    id: 'i0/sdr',
  },
  refundType: {
    description: 'Label for refund type field',
    defaultMessage: 'Refund Type',
    id: 'JMZ3Qp',
  },
  refundAssist: {
    description: 'Value for refund assist type',
    defaultMessage: 'Refund Assist',
    id: 's1CBrP',
  },
});
